import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { Observable, throwError } from "rxjs";
import { Router } from "@angular/router";

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, public router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.authService.getToken();
        req = req.clone({
            setHeaders: {
                Authorization: "Bearer " + authToken
            },
            withCredentials: true
        });
        return next.handle(req).catch(x => this.handleAuthError(x));
    }
    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401) {
            const path = this.router.url || window.location.pathname || '';
            const onAuthPage = /\/login(\/|$|\?)/i.test(path)
                || /\/loggedout(\/|$|\?)/i.test(path)
                || path === '/' || path === '';

            if (!onAuthPage) {
                sessionStorage.removeItem('token');
                this.router.navigate(['/login'], { replaceUrl: true });
            }
            return throwError(err);
        }
        return throwError(err);
    }
    // public const string MethodNotFound = "5";
    // public const string LoginFailed = "2";
    // public const string Success = "1";
    // public const string RegistrationFailed = "3";
    // public const string DuplicateUser = "4";
    // public const string NotExist = "6";
    // public const string Failed = "7";
    // public const string NotPermitted = "8";
    // public const string BlankNotAllowed = "9";
    // public const string AlreadyExists = "10";
}